'use strict';
import actual from '../components/jquery.actual.min';
// import stateMgrCtrl from '../components/stateMgrCtrl';
import ssm from 'simplestatemanager';

export default function ($) {
	console.log('this comes from pathways.js example');

	var $r = [],
		$country = "";

	window.country = $country;

	var $cookie = typeof Cookies.get("currentCountry") !== "undefined" ? Cookies.get("currentCountry") : "",
		$elem = "International";

	if ($cookie === "Australia1") {
		$elem = "Domestic";
	} else if ($cookie === "Australia2") {
		$elem = "AustraliaInternational";
	};

	function updatePage() {

		//console.log('>> Update Page');

		//show correct pathways
		// var $cookie = typeof Cookies.get("currentCountry") !== "undefined" ? Cookies.get("currentCountry") : "",
		// 	$pathway = "International";

		// if ($cookie === "Australia1") {
		// 	$pathway = "Domestic";
		// 	$('.english-req').hide();
		// } else if ($cookie === "Australia2") {
		// 	$pathway = "AustraliaInternational";
		// 	$('.english-req').show();
		// }
		// else {
		// 	$('.english-req').show();
		// }
		$('.pathways-panel, .pathways-panel--accordion').each(function () {
			if ($(this).hasClass($pathway)) {
				$(this).addClass("show-panel");
				$.fn.matchHeight._update();
			} else {
				$(this).removeClass("show-panel");
			}
		});
	};

	const pathWayOnDesktop = () => {

		// console.log(">> Desktop")

		$('.pathways-panel').each(function () {

			if ($(this).hasClass($elem)) {
				$(this).show();
			};
		});

		$('.pathways-option-container').each(function () {
			var $child = $(this).children().length,
				$bordH = Math.ceil($(this).outerHeight() / 2);

			// Fixing heights
			var $pathwayElems = $('.pathways-panel:visible'),
				$pathwayElemHeights = [],
				$pathwayMaxHeight = 0;

			for (var i = 0, leng = $pathwayElems.length; i < leng; i++) {
				$pathwayElemHeights.push($($pathwayElems[i]).outerHeight());
			}

			$pathwayMaxHeight = Math.ceil(Math.max.apply(Math, $pathwayElemHeights));

			$($pathwayElems).each(function () {
				$(this).css({
					'height': $pathwayMaxHeight + 'px'
				});
			});
		});
	}

	const pathWayOnSmallDevices = () => {
		// Arrow html var

		// console.log(">> Small devices")

		var $arrowHtml = '<img src="/www_shared/assets/img/pathways-chevron.svg" class="pathways-chevron animate-fade"/>';

		// Show items based on Cookie
		// $('.pathways-panel--accordion').each(function(){
		$('.pathways-panel').each(function () {
			if ($(this).hasClass($elem)) {
				$(this).show();
			};
		});

		// Iterate over each container/accordion
		$('.pathways-option-container--accordion').each(
			function (accordionIndex) {
				// Generic vars for this container
				var $child = $(this).children().length,
					$newHeight = [],
					$parentDivision = 0,
					$totalDivision = 0,
					$biggestHeight = 0;

				// Iterate over child items and store data
				$(this).find('.pathways-option').each(function (index) {
					var height = $(this).actual('outerHeight'),
						division = Math.ceil(height / 12);
					$newHeight.push(division * 12);
					$totalDivision += division;
				});

				// Remove arrows from very last row or the animation timing is visually weird
				$(this).find('.pathways-option:last-child .arrow-animation-container--big').remove();
				$(this).find('.pathways-option:last-child .arrow-animation-container--small').remove();

				// Get the number of divisions / 2 = number of arrows to show
				$parentDivision = (Math.max.apply(Math, $newHeight) / 12) / 2;

				// Set the height value
				$biggestHeight = Math.max.apply(Math, $newHeight);

				// Iterate over each child after getting all the data
				$(this).find('.pathways-option').each(function () {
					// Get arrow containers for reference
					var $arrowBig = $(this).find('.arrow-animation-container--big').html(''),
						$arrowSmall = $(this).find('.arrow-animation-container--small').html('');

					// Update height
					$(this).css({
						'height': $biggestHeight + 'px'
					});

					// Add arrows based on number of divisions
					for (var i = 1, leng = $parentDivision; i < leng; i++) {
						$arrowBig.append($arrowHtml);
						$arrowSmall.append($arrowHtml);
					};
				});
			}
		);

		/////////////////////
		// Arrow Animation //
		/////////////////////
		var $breakLoop = false;

		// Have generic animation
		function fadeAnim(elem, rows) {

			var $elemSet = elem,
				$rows = rows;

			/////////////////////
			// Animation
			////////////////////
			function arrowFade(elems, index, rows) {
				if (!$breakLoop) {
					if (index < elems.length) {
						var item = elems[index],
							$index = index,
							animSpeed = 140,
							rowNum = rows;

						// Reset just in case
						$(item).css({ opacity: 0 });

						// $(item).css({
						//     opacity: 0.4
						// });
						// $(item).css({
						//     opacity: 0
						// });
						// setTimeout(function(){
						//     arrowFade($elemSet, $index + 1, rowNum);
						// }, animSpeed);

						// setTimeout(function(){
						// }, animSpeed/rowNum);

						$(item).animate({
							opacity: 0.2
						}, animSpeed, 'linear',
							function () {

								// Ok amount of rows, enough time for animations to finish
								if (rowNum > 1) {
									arrowFade($elemSet, $index + 1, rowNum);
								}

								////////////////
								$(item).animate({
									opacity: 0.4
								}, animSpeed, 'linear',
									function () {

										////////////////
										$(item).animate({
											opacity: 0.2
										}, animSpeed, 'linear',
											function () {
												// Small amount of rows, reduce trails to stop interference in the cycling
												if (rowNum <= 1) {
													arrowFade($elemSet, $index + 1, rowNum);
												}
												////////////////
												$(item).animate({
													opacity: 0
												}, ((rowNum > 2) ? (animSpeed * 3) : (animSpeed * 2)), 'linear',
													function () {
														////////////////
														// arrowFade($elemSet, $index+1);

														////////////////
													}
												);
												////////////////
											}
										);
										////////////////
									}
								);
								////////////////
							}
						);
					} else {
						// Reset
						arrowFade($elemSet, 0, $rows);
					};
				} else {
					// Break Loop
				}
			};

			// Initial Trigger
			arrowFade($elemSet, 0, $rows);
		};

		// Use length to increment and set the delay
		// Break it all up into separate accordions
		function loopTimingCtrl(elem) {
			var $elemSet = $(elem).find('.arrow-animation-container--small .pathways-chevron'),
				$rows = $(elem).find('.arrow-animation-container--small').length;

			// if ($(window).outerWidth() > 767) {
			var $elemSet2 = $(elem).find('.arrow-animation-container--big .pathways-chevron'),
				$rows2 = $(elem).find('.arrow-animation-container--big').length
			// }

			fadeAnim($elemSet, $rows);
			fadeAnim($elemSet2, $rows2);
		};

		// $('.pathways-panel--accordion').on('hide.bs.collapse', function(e){
		//     // console.log('>> Break Loop');
		//     $breakLoop = true;
		// });

		// $('.pathways-panel--accordion').on('show.bs.collapse, shown.bs.collapse', function(e){
		// 	$breakLoop = false;
		// 	loopTimingCtrl(e.currentTarget);
		// });

		/////////////////////////
		// Vic: Always animate //
		/////////////////////////
		$('.pathways-panel--accordion').each(function () {
			loopTimingCtrl(this);
		});
	}

	// stateMgrCtrl(
	//     [
	//         {
	//             id: "pathway-smalldevice",
	//             qry: "(max-width: 991px)",
	//             entFnc: pathWayOnSmallDevices,
	//             lveFnc: false
	//         },
	//         {
	//             id: "pathway-desktop",
	//             qry: "(min-width: 1200px)",
	//             entFnc: pathWayOnDesktop,
	//             lveFnc: false
	//         }
	//     ]
	// );

	ssm.addStates([{
		id: 'pathway-smalldevices',
		query: '(max-width: 1199px)',
		onEnter: () => {
			pathWayOnSmallDevices();
		},
		onLeave: () => {
		}
	}, {
		id: 'pathway-desktop',
		query: '(min-width: 1200px)',
		onEnter: () => {
			pathWayOnDesktop();
		},
		onLeave: () => {
		}
	}]);



	$(document)
		.on('change',
			// '[lang-change-select-option]',
			'[lang-change-select]',
			// '.countrySelectorContainer-course',
			function () {
				// Update Country
				$country = $(this).find("option:selected").data('value');
				Cookies.set("currentCountry", $country, { expires: 365 });

				var $cookie = typeof Cookies.get("currentCountry") !== "undefined" ? Cookies.get("currentCountry") : "",
					$elem = "International";
				if ($cookie === "Australia1") {
					$elem = "Domestic";
				} else if ($cookie === "Australia2") {
					$elem = "AustraliaInternational";
				};
				$(".pathways-panel, .pathways-panel--accordion").each(
					function() {
						if ($(this).hasClass($elem)) {
							$(this).show();
						} else {
							$(this).hide();
						}
					}
				);

			})
		.ready(function () {
			if ($cookie === "") {
				// $("[lang-change-select--button]").click();
				$('.countrySelector').val("Australia2");
				$('.countrySelector').change();
			} else {
				$('.countrySelector').val($cookie);
				$('.countrySelector').change();
			};
		});
}



// WEBPACK FOOTER //
// ./src/_js/partials/pathways.js